import { type Theme } from '@mui/material'
import { type SxProps } from '@mui/system'
import { grey, shade } from '../../../../colors'

export const getSurveySectionCardSx = (theme: Theme): SxProps<Theme> => ({
  border: `1px solid ${shade[650]}`,
  p: `${theme.spacing(4)} ${theme.spacing(6)}`,
  borderRadius: theme.spacing(2),
  backgroundColor: grey[0],
  m: 0,
  '&.Mui-expanded': {
    m: 0
  },
  '&::before': {
    content: 'none'
  }
})

export const surveySectionListSx: SxProps<Theme> = {
  width: '100%',
  // Pull the section stack up slightly so the first card sits closer to the
  // Survey Results badges without changing the header container padding.
  mt: -2,
  '& > .MuiAccordion-root + .MuiAccordion-root': {
    mt: 3
  }
}

export const surveySectionSummaryLayoutSx = {
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  pr: 3
}
